// @flow
export default function getUgcArchetype(ugctype: UgcType): UgcType {
  switch (ugctype) {
    case 'Review':
    case 'MediaFirst':
      return 'Review';

    case 'Question':
    case 'SeededQuestion':
      return 'Question';

    case 'Answer':
    case 'BrandAnswer':
    case 'SeededAnswer':
      return 'Answer';

    case 'BrandMerchantResponse':
    case 'MerchantResponse':
      return 'MerchantResponse';

    default:
      return ugctype;
  }
}



// WEBPACK FOOTER //
// ./src/models/getUgcArchetype.js